import { IServices } from "@netent/origin";
import { MoneyType } from "@netent/playui";
import { PlayUIListenerCreator } from "../../types";

export const onMoneyTypeChangeRequest: PlayUIListenerCreator = (
  services: IServices
) => (type: MoneyType) => {
  switch (type) {
    case MoneyType.CASH:
      services.money.setType("cash");
      break;
    case MoneyType.COINS:
      services.money.setType("coins");
      break;
  }
};
